const ButtonsContainer = ({ onChatClick }) => {
  return (
    <div className="buttons-container">
      <button className="chat-button" onClick={onChatClick}>
        <span className="btn-bg-1"></span>
        <span className="btn-bg-2"></span>
        <span className="btn-bg-3"></span>
      </button>
      <div className="btn-name">Чат</div>
    </div>
  );
};

export default ButtonsContainer;
